/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandp21Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump command" |
*
* @param {Ahu_History_Key_Commandp21Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandp21 = /** @type {((inputs?: Ahu_History_Key_Commandp21Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandp21Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump command")
	return /** @type {LocalizedString} */ ("Commande pompe droite/basse")
});
export { ahu_history_key_commandp21 as "ahu_history_key_commandP2" }